import { CategoryType } from "../types/baseTypes";
import { fetchFromVolatileServer } from "../utils/fetchFromVolatileServer";
import { getUrl, validURL } from "../utils/url";

/**
 * @param category the category you want to get...
 * @param locale  optional if not given falls back to default locale
 * @param defaultLocale optional if not given falls back to default locale
 * @returns {Promise<*>}
 */
export const getCategories = async ({
  category,
  locale,
  defaultLocale,
}: {
  category: string;
  locale?: string;
  defaultLocale?: string;
}) => {
  const categoryRes = await fetchFromVolatileServer(
    getUrl(locale, defaultLocale) + "/" + category,
  );
  const categories: CategoryType[] = await categoryRes.json();
  const newCat = categories.map((cat) => {
    if (cat.acf.link && validURL(cat.acf.link)) {
      cat.acf.link = new URL(cat.acf.link).pathname;
    }
    return cat;
  });
  return newCat;
};
